var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_20158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.38236L9.73282 2.05685L9.73707 11.4449L0.00889091 11.5003L0 3.38236ZM9.72818 12.5266L9.73574 21.9229L0.00755455 20.5854L0.00700909 12.4636L9.72818 12.5266ZM10.908 1.88345L23.8129 0V11.3255L10.908 11.428V1.88345ZM23.8159 12.615L23.8129 23.8895L10.908 22.0682L10.8899 12.5939L23.8159 12.615Z",
    fill: "#00ADEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_20158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/Windows.c3f0e637a42f84caed73f5492e37d1ff.svg";
export { ForwardRef as ReactComponent };